/**
 * Login Component
 * 
 * JWT-based authentication - NO password storage
 */

import React, { Component, Fragment, useState } from "react";
import "./Login.css";

import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as actions from "../../store/actions";

import { toast } from "react-toastify";

import Input from "../../containers/UI/Input/Input";
import Spinner from "../../containers/UI/Spinner/Spinner";

import PinInput from "react-pin-input";
import apiClient from "../../services/apiClient";
import { API_ENDPOINTS } from "../../config/api.config";

import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

class SignupInputPassword extends Component {
  state = { showPass: false };

  toggleShowPass = () => {
    this.setState({ showPass: !this.state.showPass });
  };
  render() {
    let props = this.props;
    let { showPass } = this.state;
    return (
      <div className="inputClass">
        <label htmlFor={props.type} className="signupInputLabel">
          {props.label}
        </label>
        <div className="signupInputPassInput">
          <input
            className="signupInputPass"
            type={!showPass ? "password" : "text"}
            id={props.type}
            name={props.name}
            onChange={props.onChange}
            value={props.value}
            style={{ borderRadius: "4px 0 0 4px" }}
          />
          <div className="signupInputPassButton" onClick={this.toggleShowPass}>
            {!showPass ? (
              <VisibilityOffIcon color="inherit" />
            ) : (
              <VisibilityIcon color="inherit" />
            )}
          </div>
        </div>
      </div>
    );
  }
}

const LoginForm = (props) => {
  return (
    <Fragment>
      <form onSubmit={props.onSubmitHandler} className="contentBox">
        <span className="boxTitle">Log in</span>

        <div className="loginInputs">
          <Input
            type="email"
            label="Email Address"
            name="email"
            value={props.email}
            onChange={props.onInputHandler}
            editable
          />
          <SignupInputPassword
            type="password"
            label="Password"
            name="password"
            value={props.password}
            onChange={props.onInputHandler}
            editable
          />
        </div>

        <span
          className="forgotPass"
          onClick={() => props.onScreenChange("PASSWORD")}
        >
          Forgot your password?
        </span>

        <div className="contentButton">
          <input type="submit" value="Log in" onClick={props.onSubmitHandler} />
        </div>
      </form>
    </Fragment>
  );
};

const ResetPasswordForm = (props) => {
  return (
    <Fragment>
      <form onSubmit={props.onSubmitHandler} className="contentBox">
        <span className="boxTitle">Password assistance</span>

        <div className="passText">
          <span className="passwordAsistanceText">
            Enter the email associated with.
          </span>
          <span className="passwordAsistanceText">your D'Butler account.</span>
        </div>

        <div className="loginInputs">
          <Input
            type="email"
            label="Email Address"
            name="email"
            value={props.email}
            onChange={props.onInputHandler}
            editable
          />
        </div>

        <div className="contentButton passwordResetButton">
          {props.loading ? (
            <Spinner />
          ) : (
            <input
              type="submit"
              value="Continue"
              onClick={props.onSubmitHandler}
            />
          )}
        </div>
      </form>
    </Fragment>
  );
};

const CodeForm = (props) => {
  return (
    <Fragment>
      <form className="contentBox">
        <span className="boxTitle">Password assistance</span>

        <div className="passText">
          <span className="passwordAsistanceText">
            Please enter the 4 digits we sent in your email.
          </span>
        </div>

        <div className="codeInputs">
          <PinInput
            length={6}
            initialValue=""
            onChange={() => {}}
            type="numeric"
            focus
            style={{ padding: "10px" }}
            inputStyle={{
              width: " 46px",
              height: "60px",
              background: "#ffffff 0% 0% no-repeat padding-box",
              border: "1px solid #dcdee3",
              borderRadius: "4px",
              marginLeft: "5px",
              marginRight: "5px",
              fontFamily: "Source Sans Pro",
              fontSize: "24px",
              textAlign: "center",
            }}
            // inputFocusStyle={{ borderColor: "blue" }}
            onComplete={(value, index) => {
              props.onComplete(value);
            }}
          />
        </div>
      </form>
    </Fragment>
  );
};

const NewPasswordForm = (props) => {
  return (
    <Fragment>
      <form onSubmit={props.onSubmitHandler} className="contentBox">
        <span className="boxTitle">Password assistance</span>

        <div className="passText newPassText">
          <span className="passwordAsistanceText">
            Your identity has been verified! In order to proceed to
          </span>
          <span className="passwordAsistanceText">
            your account, you need to set up a new password.
          </span>
        </div>

        <div className="loginInputs">
          <Input
            type="password"
            label="Your new password:"
            name="newPass"
            value={props.newPass}
            onChange={props.onInputHandler}
            editable
          />
          <Input
            type="password"
            label="Please enter the new password again:"
            name="newPass1"
            value={props.newPass1}
            onChange={props.onInputHandler}
            editable
          />
        </div>

        <div className="contentButton newPass">
          <input
            type="submit"
            value="Confirm new password"
            onClick={props.onSubmitHandler}
          />
        </div>
      </form>
    </Fragment>
  );
};

const Login = (props) => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [codeValue, setCodeValue] = useState("");
  const [newPass, setNewPass] = useState("");
  const [newPass1, setNewPass1] = useState("");

  const onInputHandler = (event) => {
    const { name, value } = event.target;
    if (name === "email") setEmail(value);
    else if (name === "password") setPassword(value);
    else if (name === "newPass") setNewPass(value);
    else if (name === "newPass1") setNewPass1(value);
  };

  const codeComplete = async (value) => {
    try {
      // Verify the code is valid
      // The reset password flow doesn't require auth, just the code
      setCodeValue(value);
      onScreenChangeHandler("NEWPASS");
    } catch (error) {
      toast.error("Code not valid, please try again!", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
  };

  const onSubmitHandler = () => {
    // validate later on (required)
    props.onLoginSubmit(email, password, navigate);
  };

  const onSignupHandler = () => {
    // Sign up is not yet implemented
  };

  const onScreenChangeHandler = (value) => {
    props.onScreenChange(value);
  };

  const sendEmailHandler = (e) => {
    e.preventDefault();
    props.onResetPasswordSubmit(email);
  };

  const sendNewPassword = (e) => {
    e.preventDefault();

    if (newPass === "" || newPass1 === "" || newPass !== newPass1) {
      toast.error("Passwords don't match!", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    } else {
      props.sendNewPass(codeValue, newPass);
    }
  };

  const { loadingLogin, screen, loadingResetPass } = props;
  let displayForm = null;
  
  switch (screen) {
    case "LOGIN":
      displayForm = (
        <LoginForm
          onSubmitHandler={onSubmitHandler}
          onInputHandler={onInputHandler}
          onScreenChange={onScreenChangeHandler}
          email={email}
          password={password}
        />
      );
      break;
    case "PASSWORD":
      displayForm = (
        <ResetPasswordForm
          onSubmitHandler={sendEmailHandler}
          onInputHandler={onInputHandler}
          loading={loadingResetPass}
          email={email}
          password={password}
        />
      );
      break;

    case "CODE":
      displayForm = <CodeForm onComplete={codeComplete} />;
      break;

    case "NEWPASS":
      displayForm = (
        <NewPasswordForm
          onSubmitHandler={sendNewPassword}
          onInputHandler={onInputHandler}
          newPass={newPass}
          newPass1={newPass1}
        />
      );
      break;

    default:
      displayForm = (
        <LoginForm
          onSubmitHandler={onSubmitHandler}
          onInputHandler={onInputHandler}
          onScreenChange={onScreenChangeHandler}
          email={email}
          password={password}
        />
      );
      break;
  }
  
  return (
    <div className="loginPage">
      <div className="content">
        <div className="logoImg">
          <img
            src={`${process.env.PUBLIC_URL}/img/DButler-Basic-Logo-DarkBackground-large.png`}
            alt="Logo"
          />
        </div>
        {/* <span className="title">DBatler</span> */}
        <div className="contentBox">
          {loadingLogin || loadingResetPass ? <Spinner /> : displayForm}
        </div>
        {screen === "LOGIN" ? (
          <div className="registerBox">
            <span className="registerTitle">Don't have an account?</span>
            <input
              type="button"
              value="Sign up"
              onClick={onSignupHandler}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    profile: state.auth.profile,
    loadingLogin: state.auth.loadingLogin,
    screen: state.auth.screen,
    loadingResetPass: state.auth.loadingResetPass,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onLoginSubmit: (email, password, navigate) =>
      dispatch(actions.login(email, password, navigate)),
    onResetPasswordSubmit: (email) => dispatch(actions.forgotPassword(email)),
    onScreenChange: (screen) => dispatch(actions.changeScreen(screen)),
    sendNewPass: (code, pass) => dispatch(actions.sendNewPass(code, pass)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
